import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { NewsEffects } from './news.effects';
import { NewsService } from './news.service';
import { NewsReducer } from './news.reducer';

export const provideNewsFeature = () => [
  provideState('news', NewsReducer),
  provideEffects(NewsEffects),
  NewsService
];
